export function mapResetNorthPitch(options = { animate: true }) { return this._animateCamera(0, 0, options); }
